import React from 'react';
import styled from 'styled-components';
import { withMap } from 'react-mapbox-gl/lib-esm/context';
import type { Map } from 'mapbox-gl';

interface Props {
  id: string;
  name?: string;
  activeBgColor: string;
  icon: React.MemoExoticComponent<any>;
  onClick?: () => void;
  map: Map;
  disabled?: boolean;
  borderRadius?: TemplateStringsArray;
}

interface State {
  active: boolean;
}

class LayerControlButton extends React.PureComponent<Props, State> {
  constructor(props) {
    super(props);
    this.toggleHandler = this.toggleHandler.bind(this);
    this.state = { active: false };
  }

  UNSAFE_componentWillMount() {
    const { id } = this.props;
    this.setState({ active: this.isLayerVisible(id) });
  }

  isLayerVisible(layerId) {
    const { map } = this.props;
    return map && map.getLayoutProperty(layerId, 'visibility') === 'visible';
  }

  toggleLayer(layerId, flag) {
    const show = flag === undefined ? !this.isLayerVisible(layerId) : flag;
    const { map } = this.props;

    if (map) {
      map.setLayoutProperty(layerId, 'visibility', show ? 'visible' : 'none');
    }

    return show;
  }

  toggleHandler() {
    const { id, onClick } = this.props;

    if (onClick) {
      onClick();
    }

    this.setState((state) => {
      const active = this.toggleLayer(id, !state.active);
      this.setState({ active });
    });
  }

  render() {
    const {
      name,
      icon,
      activeBgColor,
      borderRadius,
      disabled = false,
    } = this.props;
    const { active } = this.state;

    const Icon = styled(icon)<{ isActive: boolean }>`
      stroke: #4d4d4d;
      width: 36px;
      height: 36px;

      ${({ isActive }) =>
        isActive &&
        `
          stroke: #fff;
      `}
    `;

    return (
      <LayerButton
        title={name}
        disabled={disabled}
        borderRadius={borderRadius}
        onClick={this.toggleHandler}
        $bgColor={active && activeBgColor}
      >
        <Icon isActive={active} />
      </LayerButton>
    );
  }
}

const LayerButton = styled.button<{
  $bgColor: string | false;
  borderRadius?: TemplateStringsArray;
}>`
  width: 48px;
  height: 48px;
  background: #fff;
  border: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  ${(props) => props.borderRadius}
  ${({ $bgColor }) =>
    $bgColor &&
    `
      background-color: ${$bgColor};
  `}
`;

export default withMap(LayerControlButton);
